import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { makeGetFullSelectionData } from '../../../modules/events/selectors';
import { slipSelectionClick } from '../actions';
import { isSelectionInSlip } from '../selectors';

export const SelectionButton = ({ active, onClick, selection }) => {
  const buttonClassName = classNames(
    'bb-selection-button',
    { 'bb-selection-button--active': active }
  );

  return (
    <div
      className={buttonClassName}
      onClick={
        () => onClick(selection, active)
      }
    >
      {selection.selectionPriceNum}/{selection.selectionPriceDen}
    </div>
  );
};

SelectionButton.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  selection: PropTypes.object.isRequired
};

const makeMapStateToProps = (initialState, initialProps) => {
  const getFullSelectionData = makeGetFullSelectionData();
  return (state) => ({
    active: isSelectionInSlip(state, initialProps),
    selection: getFullSelectionData(state, initialProps)
  });
};

const mapDispatchToProps = {
  onClick: slipSelectionClick
};

export default connect(makeMapStateToProps, mapDispatchToProps)(SelectionButton);
